import moment from 'moment';

export function dateToUnixEpoch(date: Date): number {
  const dateObj = moment(date).utc().unix();

  return dateObj;
}
